import { LoginId } from '@auth0/auth0-acul-js';
import { useState } from 'react';
import MainLayout from "../../components/layouts/MainLayout.tsx";
import {Button, Stack} from "braid-design-system";
import FormCard from "../../components/shared/FormCard/FormCard.tsx";
import FormHeader from "../../components/shared/FormHeader/FormHeader.tsx";
import FormStack from "../../components/shared/FormStack.tsx";
import SocialButtons from "../../components/shared/SocialButtons/SocialButtons.tsx";

export const LoginIdScreen = () => {
    const loginManager = new LoginId();

    const [email, setEmail] = useState('');

    const pageContentTranslated = {
        forgotPassword: 'Forgot password?',
        tertiaryRegisterLink: 'Don’t have an account? Register',
        signIn: 'Sign in',
        formSubmitBtn: 'Email me a sign in code',
        successCodeSent:
            'Code sent successfully. You will be redirected shortly.',

        successSignedIn:
            'You have successfully signed in. You will be redirected shortly.',
    };
    if (!loginManager.transaction.alternateConnections) {
        console.error('No alternate connections available.');
    }else{
        console.log(`supported alternate connections: ${JSON.stringify(loginManager.transaction.alternateConnections)}`);
    }
    console.log(`current strategy: ${loginManager.transaction.connectionStrategy}`)


    const onContinueWithPasskey=() =>{
        loginManager.passkeyLogin({ username: email});
    }

    const onContinueClick = () =>{

        loginManager.login({username: email});

    }

    const initiateForgetPassword = () =>{
        window.location.assign(loginManager.screen.resetPasswordLink!)
    }

    const onContinueWithCodeClick = () =>{
        if (loginManager.transaction.connectionStrategy ==='auth0') {
            const params = {
                response_type: "code",
                client_id: loginManager.client.id,
                redirect_uri: "https://{domain}/callback",
                scope: "openid profile email",
                audience: "{audience}",
                login_hint: email,
                connection: 'email'
            };

            const queryString = new URLSearchParams(params).toString();
            const fullUrl = `/authorize?${queryString}`;
            window.location.href = fullUrl;
        }
    }

    const onContinueSocial = async(socialProvider:any) =>{


        await loginManager.federatedLogin({ connection: socialProvider})


    }

    return (
            <MainLayout>
                <Stack space="none" >
                    <FormCard>
                        <FormHeader title="Sign in" />
                            <FormStack>
                                <input
                                    type="email"
                                    placeholder="Enter your email1"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                />
                                <Stack space="none">
                                    <Button
                                        tone="brandAccent"
                                        onClick={onContinueClick}
                                    >
                                        Continue
                                    </Button>
                                    {
                                        loginManager.transaction.connectionStrategy ==='auth0' &&
                                        <Button
                                            tone="brandAccent"
                                            onClick={onContinueWithCodeClick}
                                        >
                                            {pageContentTranslated.formSubmitBtn}
                                        </Button>
                                    }

                                </Stack>
                        </FormStack>
                        <SocialButtons callback={onContinueSocial} />
                        <Stack space="none">
                            <Button
                                tone="neutral" variant="ghost"
                            onClick={onContinueWithPasskey}
                        >
                            Continue with Passkey
                        </Button>
                            <Button tone="neutral" onClick={initiateForgetPassword}>Forget Password</Button>
                        </Stack>
                    </FormCard>
                </Stack>

            </MainLayout>
    );
};

export default LoginIdScreen;